import functionCommon from "../common/function";
import CONSTANT from "../constant/constant";
import { leaveConfigConstants } from "../constant/leaveConfig.constants";
import { leaveConfig } from "../services/leaveConfig.service";

const _errorCode = CONSTANT.errorCode;

export const getConfigList = () => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        leaveConfig.getConfig().then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(list) {
        return { type: leaveConfigConstants.GET_CONFIG_LIST_SUCCESS, list };
    }
};

export const updateConfigList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(updating());
        leaveConfig.updateConfig(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    leaveConfig.getConfig().then((res) => {
                        if (!res) return;
                        switch (res["http_code"]) {
                            case _errorCode.APISuccess:
                                dispatch(success(res.result));
                                break;
                            case _errorCode.TOKENExpired:
                                functionCommon.logout();
                                break;

                            case _errorCode.APIInvalids:
                                functionCommon.logout();
                                break;

                            case _errorCode.ClientNotPermission:
                                functionCommon.logout();
                                break;

                            default:
                                window.location = "/error/404";
                                break;
                        }
                    });
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    dispatch(failure(res["error_code"]));
                    break;
            }
        });
    };

    function success(newList) {
        return { type: leaveConfigConstants.UPDATE_CONFIG_LIST_SUCCESS, newList };
    }

    function updating() {
        return { type: leaveConfigConstants.UPDATE_CONFIG_LIST };
    }

    function failure(error) {
        return { type: leaveConfigConstants.UPDATE_CONFIG_LIST_FAIL, error };
    }
};

export const clearMessage = () => {
    return (dispatch) => {
        dispatch({ type: leaveConfigConstants.CLEAR_MESSAGE });
    };
};
